<template>
  <v-dialog :value="value" @input="e => $emit('input', e)" :max-width="maxWidth" :persistent="persistent">
    <v-card>
      <div :class="{ 'static-header': isHeaderFixed }" :style="headerFixStyle" >
        <v-card-title class="primary--text text--darken-2 py-1 px-5 py-5 d-flex fixed-title-height " v-if="buttonsOnTop">
          <v-row class="align-center">
            <v-col class="flex-grow-1">
              <h1 class="app-page-card__header ml-4 overflow-hidden">
                <slot name="title" />
              </h1>
            </v-col>
            <div v-if="$slots['header-actions']" class="d-flex flex-shrink-1 pa-0">
              <v-spacer />
              <slot name="header-actions" />
            </div>
            <div v-else class="d-flex flex-shrink-1 pa-0">
              <v-spacer />
              <v-toolbar flat dense>
                <app-btn
                    class="mr-5 btn-cancel"
                    :block="$vuetify.breakpoint.xs"
                    @click="$emit('cancel')"
                    outlined
                    v-if="cancelBtnText"
                >
                  {{cancelBtnText}}
                </app-btn>
                <app-btn
                    class="btn-confirm"
                    :disabled="isConfirmButtonDisabled"
                    :block="$vuetify.breakpoint.xs"
                    :loading="loading"
                    v-if="confirmBtnText"
                    @click="$emit('confirm')"
                >
                  {{confirmBtnText}}
                </app-btn>
              </v-toolbar>
            </div>
          </v-row>
        </v-card-title>

        <v-card-title class="px-10 py-5 d-flex justify-center" v-else>
          <p class="primary--text app-modal-prompt__title-text ma-0">
            <slot name="title" />
          </p>
        </v-card-title>
        <v-divider />
      </div>

      <slot name="modal-tabs-title"/>
      <div class="pa-8">
        <v-card-text class="ma-0 pa-0">
          <div class="ma-0 pa-0" >
            <slot />
          </div>
        </v-card-text>
        <v-card-actions class="mt-8 mb-0 mx-0 pa-0 justify-space-between" v-if="!buttonsOnTop">
          <v-container fluid  class="ma-0 pa-0">
            <div v-if="$slots['header-actions']">
              <slot name="header-actions"/>
            </div>

            <v-row
              v-else
              class="ma-0 pa-0"
              :class="showCancelBtn && showConfirmBtn ? 'justify-space-between' : 'justify-center'"
            >
              <v-col 
                cols="12" sm="6" 
                class="d-flex ma-0 pa-0"
                v-if="showCancelBtn"
                :class="showCancelBtn && showConfirmBtn ? 'justify-start' : 'justify-center'"
              >
                <app-btn 
                  large
                  :block="$vuetify.breakpoint.xs"
                  outlined
                  @click="$emit('cancel')"
                >
                  {{cancelBtnText}}
                </app-btn>
              </v-col>
              <v-col 
                cols="12" sm="6" 
                class="d-flex ma-0 pa-0"
                v-if="showConfirmBtn"
                :class="showCancelBtn && showConfirmBtn ? 'justify-end' : 'justify-center'"
              >
                <app-btn 
                  large
                  :disabled="isConfirmButtonDisabled"
                  :block="$vuetify.breakpoint.xs"
                  :loading="loading"
                  @click="$emit('confirm')"
                >
                  {{confirmBtnText}}
                </app-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </div>     
    </v-card>
  </v-dialog>
</template>

<script>
import AppBtn from '@/components/layout/AppBtn.vue'

export default {
 name: 'AppModalPrompt',

 components: { 
  AppBtn 
},

 props: {
  value: {
    type: Boolean,
    required: true,
   },

    loading: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },

    width: {
      type: [String, Number],
      required: false,
      default: ''
    },

    isConfirmButtonDisabled: {
      type: Boolean,
      default: false,
    },

    showConfirmBtn: {
      type: Boolean,
      default: true,
    },

    showCancelBtn: {
      type: Boolean,
      default: true,
    },

    confirmBtnText: {
      type: String,
      default: 'Confirmar'
    },

    cancelBtnText: {
      type: String,
      default: 'Cancelar'
    },

   buttonsOnTop: {
     type: Boolean,
     default: false,
   },
   isHeaderFixed: {
     type: Boolean,
     required: false,
     default: false
   }
 },

 data() {
  return {}
 },

 computed: {
  maxWidth() {
    if (this.width) {
      return this.width
    }

    if (this.$vuetify.breakpoint.smAndDown) {
      return '100%'
    }

    return '460px'
  },
   headerFixStyle() {
     let top = "0px";
     if (this.isHeaderFixed) {
       top = "0px";
     }else if (this.isHeaderFixed && this.$slots['header-actions']) {
       if (this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name == 'sm') {
         top = "56px";
       }else {
         top = "61px";
       }
     }
     return { 'top': top };
   },
 },

 methods: {

 }
}
</script>

<style>
.app-modal-prompt__title-text {
  font-size: 20px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: center;
}
.v-dialog {
  border-radius: 24px !important; /* class="rounded-xl" */
}

.btn-confirm, .btn-cancel {
  font-size: 1.25rem;
}

.fixed-title-height {
  min-height: 56px;
}

.static-header {
  z-index: 1;
  background-color: white;
  position: sticky;
}
</style>